import React from 'react';

import { Box, CircularProgress, Container, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ExportPDFButton from 'src/common/components/ExportPDFButton';
import { useAppDispatch } from 'src/common/hooks/reduxHooks';
import { EditNoteParams } from 'src/florence/types/RouterState';

import { useGetNoteByIDQuery } from '../../../common/apis/FlorenceApi';
import ExpandableTypography from '../../../common/components/ExpandableTypography';
import { FlorencePAGES } from '../../../common/components/tfa-auth/constants/pages';
import { SheetStatus } from '../../../common/types/SaveSheet';

import SavedSheetsContainer from './components/SavedSheetsContainer';

const SavedSheetScreen: React.FC = () => {
  const { id } = useParams();

  const { data: savedSheet, isFetching } = useGetNoteByIDQuery(id ?? '', {
    refetchOnMountOrArgChange: true,
  });

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (!isFetching) {
      navigate(
        savedSheet?.clinicNote
          ? FlorencePAGES.editSheet
          : FlorencePAGES.editOPNote,
        {
          state: {
            note: savedSheet,
          } as EditNoteParams,
        }
      );
    }
  }, [navigate, dispatch, savedSheet, isFetching]);

  return (
    <Box
      className='responsive-padding light-blue-background'
      sx={{
        minHeight: '100vh',
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          textAlign: 'center',
        }}
      >
        <Stack spacing={'30px'}>
          {isFetching && (
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                paddingTop: '48px',
              }}
            >
              <CircularProgress color='primary' size='64px' />
            </Box>
          )}
          {savedSheet && savedSheet.status !== SheetStatus.FINALIZED && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
              }}
            >
              <ExportPDFButton isDisabled={isFetching} note={savedSheet} />
            </Box>
          )}
          {!isFetching && (
            <ExpandableTypography lineCount={6}>
              {savedSheet?.scanText ?? ''}
            </ExpandableTypography>
          )}
          {!isFetching && savedSheet && (
            <SavedSheetsContainer savedSheet={savedSheet} />
          )}
        </Stack>
      </Container>
    </Box>
  );
};

export default SavedSheetScreen;
